import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-f965b-schedule-b-entry',
    templateUrl: './f965b-schedule-b-entry.component.html',
    styleUrls: ['./f965b-schedule-b-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class F965BScheduleBEntryComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  filterParams: any = {};
  rowData: any = {};
  baseURLs: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  showFormLoader = true;
  entityList: any[] = [];
  private isInitialized = false;
  partIHeader: any[] = [];
  partIRows: any[] = [];
  partIIHeader: any[] = [];
  partIIRows: any[] = [];
  partIIIHeader: any[] = [];
  partIIIRows: any[] = [];
  allRows: any[] = [];

  @Input('filter-params')
  set _filter_params(v: string) {
    try {
      const params = safeJsonInput<any>(v, null, 'f965b-schedule-b-entry.parse1');
      if (params && Object.keys(params).length > 0) {
        this.filterParams = params;
        this.tryInit();
      }
    } catch (e) {
      console.log('Filter params input not yet stable.');
    }
  }

  @Input('base-urls')
  set _base_urls(v: string) {
    try {
      const urls = safeJsonInput<any>(v, null, 'f965b-schedule-b-entry.parse2');
      if (urls && Object.keys(urls).length > 0) {
        this.baseURLs = urls;
        this.tryInit();
      }
    } catch (e) {
      console.log('Base URLs input not yet stable.');
    }
  }

  @Input('header-data')
  set _header_data(v: string) {
    try {
      const header = safeJsonInput<any>(v, null, 'f965b-schedule-b-entry.parse3');
      if (header && Object.keys(header).length > 0) {
        this.globalService = header.globalParams;
        this.GENERAL_CONFIG = header.generalConfigData;
        this.tryInit();
      }
    } catch (e) {
      console.log('Header data input not yet stable.');
    }
  }

  @Input('row-data')
  set _row_data(v: string) {
    try {
      const data = safeJsonInput<any>(v, null, 'f965b-schedule-b-entry.parse4');
      if (data && Object.keys(data).length > 0) {
        this.rowData = data;
        this.tryInit();
      }
    } catch (e) {
      console.log('Row data input not yet stable.');
    }
  }

  constructor(private cdr: ChangeDetectorRef, private http: HttpClient) {}

  ngOnInit(): void {}

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.globalService || !this.GENERAL_CONFIG || !this.rowData || Object.keys(this.rowData).length === 0) return;
    this.isInitialized = true;
    this.entityList = [
      { key: 'Tax Year', value: this.rowData.TAX_YEAR },
      { key: 'LEID', value: this.rowData.LEID },
      { key: 'LE Name', value: this.rowData.LE_NAME }
    ];
    this.loadScheduleBData();
  }

  private loadScheduleBData(): void {
    const params: any = {
      action_id: 31742,
      tax_year: this.rowData.TAX_YEAR,
      scenario: this.rowData.SCENARIO,
      jcd_key: this.rowData.JCD_KEY,
      combination_key: this.rowData.COMBINATION_KEY,
      schedule_name: 'B'
    };
    const body = new URLSearchParams();
    Object.keys(params).forEach((k) => {
      if (params[k] !== undefined && params[k] !== null) {
        body.set(k, String(params[k]));
      }
    });
    this.http.post<any>(`${this.GENERAL_CONFIG.base_url}/loadPivotFormJson`, body.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        this.parsePivotData(data);
        this.showFormLoader = false;
        this.cdr.detectChanges();
      },
      () => {
        this.showFormLoader = false;
        this.cdr.detectChanges();
      }
    );
  }

  private parsePivotData(data: any): void {
    const list = data?.irsForm?.formItemList || [];
    const dynamicAttr = ['NA', 'NA', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];
    const rows: any[] = [];
    for (let i = 1; i < list.length; i++) {
      const row = list[i]?.dataRowList?.[0];
      const cells = row?.dataCellList || [];
      const saveParams = (row?.rowDimensions?.object_id || '').split('~');
      const tempDataObj: any = {
        num: cells[0]?.name,
        description: cells[1]?.name,
        line_order: saveParams[8],
        saveParams
      };
      if (cells.length === 3) {
        tempDataObj.lineAttrKey_a = cells[2]?.key?.split('~')?.[1];
        tempDataObj.attrib_name_a = cells[2]?.key?.split('~')?.[0];
        tempDataObj.attrib_order_a = cells[2]?.key?.split('~')?.[2];
        tempDataObj.value = this.parseCellValue(cells[2]?.value);
      } else {
        tempDataObj.list = {};
        tempDataObj.attributeList = [];
        for (let j = 2; j < cells.length; j++) {
          const suffix = dynamicAttr[j];
          tempDataObj[`lineAttrKey_${suffix}`] = cells[j]?.key?.split('~')?.[1];
          tempDataObj[`attrib_name_${suffix}`] = cells[j]?.key?.split('~')?.[0];
          tempDataObj[`attrib_order_${suffix}`] = cells[j]?.key?.split('~')?.[2];
          tempDataObj[`attrib_value_${suffix}`] = cells[j]?.value;
          tempDataObj.list[`attrib_value_${suffix}`] = this.parseCellValue(cells[j]?.value);
          tempDataObj.attributeList.push(`attrib_value_${suffix}`);
        }
      }
      rows.push(tempDataObj);
    }
    if (rows.length > 3) {
      rows[1].value = this.rowData.LE_NAME;
      rows[2].value = this.rowData.EIN;
      rows[3].value = this.rowData.TAX_YEAR;
    }
    this.allRows = rows;
    this.partIHeader = rows.slice(5, 7);
    this.partIRows = rows.slice(7, 15);
    this.partIIHeader = rows.slice(15, 17);
    this.partIIRows = rows.slice(17, 26);
    this.partIIIHeader = rows.slice(26, 28);
    this.partIIIRows = rows.slice(28, 37);
    this.computeTotals();
  }

  private parseCellValue(value: any): any {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
  }

  private computeTotals(): void {
    this.computeCalculationRows(this.partIRows);
    this.computeTotalValues(this.partIIRows, 'attrib_value_j', 'attrib_value_a');
    this.computeTotalValues(this.partIIRows, 'attrib_value_k', 'attrib_value_b');
    this.computeTotalValues(this.partIIIRows, 'attrib_value_k', 'attrib_value_a');
    this.computeTotalValues(this.partIIIRows, 'attrib_value_l', 'attrib_value_b');
  }

  private computeCalculationRows(rows: any[]): void {
    rows.forEach((row) => {
      if (!row?.list) return;
      const b = Number(row.list.attrib_value_b || 0);
      const c = Number(row.list.attrib_value_c || 0);
      row.list.attrib_value_d = c - b;
      if (row.list.attrib_value_e) {
        row.list.attrib_value_f = 0;
        row.list.attrib_value_g = row.list.attrib_value_d;
      } else {
        row.list.attrib_value_g = 0;
        row.list.attrib_value_f = row.list.attrib_value_d;
      }
    });
  }

  private computeTotalValues(rows: any[], sourceAttr: string, targetAttr: string): void {
    if (!rows || rows.length === 0) return;
    let total = 0;
    rows.forEach((row) => {
      const value = Number(row?.list?.[sourceAttr]);
      if (!Number.isNaN(value)) total += value;
    });
    const targetRow = rows[8];
    if (targetRow?.list) {
      targetRow.list[targetAttr] = total;
    }
  }
}
